import IConfiguracaoAlarme from "../interfaces/IConfiguracaoAlarme";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class ConfiguracaoAlarmeService {
    async create(data: any) {
        return await api.post<IConfiguracaoAlarme>(`${resources.configuracaoAlarme}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.configuracaoAlarme}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.configuracaoAlarme}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.configuracaoAlarme}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getAllTipoAlarme(filters: any) {
        return await api.get<any>(`${resources.configuracaoAlarme}/GetAllTipoAlarme/${ToQueryString(filters)}`);
    }
}

export default new ConfiguracaoAlarmeService();
